export default __webpack_public_path__ + "static/media/info-icon.ac330963.svg";